import { Row, Col } from "react-bootstrap";
import { useState, useEffect, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import Layout from '../layouts/Layout';
import { getOneUser, addingUser, updateUser } from "../services/userServices";
import Toast from 'react-bootstrap/Toast';
import { RoleContext, AlertContext } from "../utils/contexts/RoleContext";

export default function Privacy() {
    return (
        <Layout>
            <div className="ul-tag">
                <h2>Privacy Policy for Corsia Wallet</h2>
                <Col className="mt-3 mb-4">
                    <div className="px-4 mt-3 mb-4 pt-3">
                        <p className="p-1">Welcome to <span className="fw-bold">Corsia Wallet</span>. Your privacy is important to us, and we are committed to protecting your personal data. This Privacy Policy explains how we collect, use, and safeguard your information when you use our mobile application and services.</p>
                        <h3 className="mt-3">1. Information We Collect</h3>
                        <p className="mt-3">When you use the <span className="fw-bold">Corsia Wallet</span>, we may collect the following types of information:</p>
                        <h5 className="mt-4">1.1 Personal Information</h5>
                        <ul className="">
                            <li className="p-1">Name, email address, phone number</li>
                            <li className="p-1">Government-issued identification documents for KYC verification (e.g., Aadhaar, Passport, Driving License, National ID)</li>
                            <li className="p-1">Date of birth and country of residence</li>
                        </ul>

                        <h5 className="mt-4">1.2 Transactional Information</h5>
                        <ul className="">
                            <li className="p-1">Details of transactions performed within the app, including deposits, withdrawals, and trade history</li>
                            <li className="p-1">Wallet balances for USDT and Corsia </li>
                        </ul>



                        <h5 className="mt-4">1.3 Communication & Support</h5>
                        <ul className="">
                            <li className="p-1">Emails and inquiries sent to <a className="link-opacity-10 text-primary" href="mailto:Support@v-b-h.com">Support@v-b-h.com</a></li>
                            <li className="p-1">Any additional information provided while contacting customer support</li>
                        </ul>

                        <h3 className="mt-4">2. How We Use Your Information
                        </h3>
                        <p className="mt-3">We use the collected data for the following purposes:
                        </p>
                        <ul className="">
                            <li className="p-1"><span className="fw-bold">To provide and maintain services:</span> Processing transactions, managing user accounts, and ensuring security</li>
                            <li className="p-1"><span className="fw-bold"
                            >To verify identity:</span> KYC verification and fraud prevention
                            </li>
                            <li className="p-1"><span className="fw-bold">To comply with legal obligations:</span> Ensuring adherence to financial regulations and reporting obligations
                            </li>
                            <li className="p-1"><span className="fw-bold">To improve our services:</span>  Enhancing app functionality, user experience, and security
                            </li>
                            <li className="p-1"><span className="fw-bold">To communicate with users:</span>  Sending transaction confirmations, security alerts, and customer support responses
                            </li>
                        </ul>

                        <h3 className="mt-4">3. How We Share Your Information
                        </h3>
                        <p className="mt-3">We do <span className="fw-bold">not</span> sell or rent your data to third parties. However, we may share data in the following cases:

                        </p>
                        <ul className="">
                            <li className="p-1"><span className="fw-bold">With regulatory authorities: </span>If required by law or financial regulations

                            </li>
                            <li className="p-1"><span className="fw-bold"
                            >With service providers:</span> For hosting, payment processing, and security enhancement
                            </li>
                            <li className="p-1"><span className="fw-bold">With affiliates:</span> If Corsia Wallet is involved in a merger, acquisition, or asset sale

                            </li>

                        </ul>

                        <h3 className="mt-4">4. Data Security Measures</h3>
                        <p className="mt-3">We implement strong security measures to protect your data, including:
                        </p>
                        <ul className="">
                            <li className="p-1"><span className="fw-bold">Regular Security Audits: </span>Monitoring and updating security protocols
                            </li>
                        </ul>

                        <h3 className="mt-4">5. User Rights & Choices
                        </h3>
                        <p className="mt-3">You have the right to:

                        </p>
                        <ul className="">
                            <li className="p-1"><span className="fw-bold">Access and review your personal data</span>  by requesting a copy from our support team
                            </li>
                            <li className="p-1"><span className="fw-bold"
                            >Correct inaccuracies</span> in your account details
                            </li>
                            <li className="p-1"><span className="fw-bold">Request account deletion</span> by contacting <a className="link-opacity-10 text-primary" href="mailto:Support@v-b-h.com">Support@v-b-h.com</a>
                            </li>
                            <li className="p-1"><span className="fw-bold">Withdraw consent</span> for data processing (where applicable)
                            </li>

                        </ul>

                        <h3 className="mt-4">6. Data Retention

                        </h3>
                        <p className="mt-3">We retain user data for as long as necessary to:</p>
                        <ul className="">
                            <li className="p-1">Fulfill legal and regulatory requirements

                            </li>
                            <li className="p-1">
                                Prevent fraud and unauthorized transactions
                            </li>
                            <li className="p-1">Provide continued access to transaction history

                            </li>
                        </ul>
                        <p className="">Upon account deactivation or retirement, we may retain limited information for compliance purposes.                        </p>

                        <h3 className="mt-4">7. Third-Party Links & Services</h3>
                        <p className="mt-3">Our app may include links to external websites or third-party services. We are not responsible for the privacy policies or content of these external sites.</p>

                        <h3 className="mt-4">
                            8. Updates to This Policy
                        </h3>
                        <p className="mt-3">We may update this Privacy Policy periodically. Users will be notified of significant changes via email or app notifications.
                        </p>
                        <h3 className="mt-4">
                            9. Contact Information
                        </h3>
                        <p className="mt-1">For any privacy-related inquiries, you can reach us at:</p>
                        <ul className="list-group">
                            <li className="p-1"><span className="fw-bold"
                            >Email: </span> <a className="link-opacity-10 text-primary" href="mailto:Support@v-b-h.com">Support@v-b-h.com</a>
                            </li>
                            <li className="p-1"><span className="fw-bold">Website:</span><a className="link-opacity-10 text-primary" href="#">  Corsia Wallet
                            </a>
                            </li>
                        </ul>
                    </div>
                </Col>
            </div>


        </Layout>
    );
}